exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "h1 {\r\n    text-align: center;\r\n    color: #7aa3db;\r\n}\r\n\r\ndiv {\r\n    background-color: #d1ddeb;\r\n    width: 20%;\r\n    padding: 1%;\r\n    margin: auto;\r\n}\r\n\r\n@media screen and (max-width: 1200px) {\r\n    div {\r\n        width: 70%;\r\n        margin: 0 15%;\r\n    }\r\n}\r\n\r\n@media screen and (max-width: 768px) {\r\n    div {\r\n        width: 90%;\r\n        margin: 0 5%;\r\n    }\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/apache/localhost/www/Angular/task2/src/app/app.component.css
// module id = ../../../../../src/app/app.component.css
// module chunks = 1